







import Vue from "vue";
import Login from "@/components/templates/Login/index.vue";
import snackbar from "@/shared/snackbar";

export default Vue.extend({
  components: { Login },
  methods: {
    doLogin(loginForm: any) {
      this.$store.dispatch("app/startRequest");
      this.$store.dispatch("auth/signin", loginForm)
      .then((props) => {
        this.$store.dispatch("app/endRequest");
        if (props && (props.status === "done" || props.status === "isWatingCode:SMS_MFA")) {
          const nextPath = props.path ? `/${props.path}` : "/dashboard";
          this.$router.replace(nextPath);
        }
      })
      .catch((error) => {
        this.$store.dispatch("app/endRequest");
        snackbar.error(this, { message: error });
      });
    },
    forgetPassword() {
      this.$router.push("/forgot-password");
    },
  },
});
